import React from "react";
import { Link } from "react-router-dom";
import life1 from "../../assets/header-images/life1.jpg";
import prep1 from "../../assets/header-images/prep1.jpg";
import afford1 from "../../assets/header-images/afford1.jpg";
import programs from "../../assets/header-images/prog1.jpg";
import "../../css/MainPage/MainLanding.css";

const sections = [
  {
    title: "College Prep",
    description:
      "Guides and resources to help you prepare for college, including high school planning, choosing a major, application tips, essays, and more.",
    image: prep1,
    link: "/college-prep",
    button: "Explore College Prep",
    icon: null, // Add icon here if desired
  },
  {
    title: "Afford College",
    description:
      "Learn about financial aid, scholarships, student work opportunities, and strategies to make college more affordable.",
    image: afford1,
    link: "/afford-college",
    button: "Explore Afford College",
    icon: null, // Add icon here if desired
  },
  {
    title: "College Life & Programs",
    description:
      "Discover tips for thriving in college, maximizing campus resources, finding internships, and participating in special programs.",
    image: programs,
    link: "/college-life",
    button: "Explore College Life",
    icon: null, // Add icon here if desired
  },
];

export default function College() {
  return (
    <div className="main-landing-page">
      {/* Hero Section */}
      <div
        className="main-landing-hero"
        style={{ backgroundImage: `url(${life1})` }}
      >
        <div className="main-landing-hero-overlay" />
        <div className="main-landing-hero-content">
          <h1>College Success Hub</h1>
          <div className="main-landing-hero-sub">
            Resources for college prep, affordability, and thriving in campus
            life.
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="main-landing-mission-section">
        <div className="main-landing-mission-container">
          <h2>Navigate Your College Journey</h2>
          <p>
            Whether you're planning your path to college, searching for ways to
            afford your education, or looking to make the most of your college
            experience, CollegeNav brings together the resources, tips, and
            tools you need—all in one place.
          </p>
        </div>
      </div>

      {/* Main Sections */}
      <div className="main-landing-section">
        <div className="main-landing-section-title">Explore Our Core Areas</div>
        <div className="main-landing-grid">
          {sections.map((section, idx) => (
            <div className="main-landing-card" key={idx}>
              {/* Card Accent Bar is handled by CSS ::before */}
              {/* Card Icon Area (optional, for future use) */}
              {/* <div className="main-landing-card-icon">{section.icon}</div> */}
              <div className="main-landing-card-image">
                <img src={section.image} alt={section.title} />
              </div>
              <div className="main-landing-card-info">
                <div className="main-landing-card-title">{section.title}</div>
                <div className="main-landing-card-desc">
                  {section.description}
                </div>
                <Link to={section.link} className="main-landing-link-btn">
                  {section.button}
                  <svg
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 5l5 5-5 5"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
